import React, { useCallback } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';

import { Divider } from '../divider';
import { MoveRight } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import UDButton from '../button';
import { UDTabProps } from './interfaces';
import UDText from '../text';
import { theme } from 'styles/theme/theme';

export const UdTab = ({ tab }: UDTabProps) => {
  const navigate = useNavigate();
  const isActiveTourney = useMatch(`${Pages.TOURNEYS.EDIT}/${tab.hash}/*`);
  const isActiveTeam = useMatch(`${Pages.TEAMS.EDIT}/${tab.hash}/*`);
  const isActivePlayer = useMatch(`${Pages.PLAYERS.VIEW}/${tab.hash}/*`);
  const isActive = isActiveTeam || isActiveTourney || isActivePlayer;

  const handleTabClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      const tabPath = e.currentTarget.dataset.hash;
      if (tabPath) {
        tab.onClick?.();
        navigate(tabPath, { replace: true, state: tab.state });
      }
    },
    [navigate, tab],
  );

  return (
    <div className="control flex items-center">
      <UDButton
        key={tab.hash}
        disabled={tab.disabled}
        variant={isActive ? 'primary' : 'light'}
        data-hash={tab.hash}
        onClick={handleTabClick}
        type="button"
        className="flex items-center"
      >
        {tab.label}
        {!isActive && <MoveRight size={16} className="ml-2" color={theme.colors.SurfaceRomanSilver30} />}
      </UDButton>
      {tab.subLabel && (
        <>
          <Divider type={'horizontal'} color={'#D9B244'} height={'1px'} width={'17px'} />
          <UDButton
            key={tab.hash}
            disabled={tab.disabled}
            variant={'secondary'}
            data-hash={tab.hash}
            type="button"
            className="flex items-center"
          >
            <UDText type={'subhead'} maxWidth={145}>
              {tab.subLabel}
            </UDText>
          </UDButton>
        </>
      )}
    </div>
  );
};
